export const FETCH_ZGS_NUMBER = 'FETCH_ZGS_NUMBER'
